export enum DataRegistryCategoryLayout {
	Asset = 'asset',
	Service = 'service',
	Monitor = 'monitor'
}
